module.exports = __webpack_public_path__ + "img/h_s1e2_interactions_2.65a6e7fa.png";